/* eslint-disable import/no-named-as-default */
import { formatNumberWithCommas, SellCarRequestResponseDTO } from "@alba-cars/common-modules";

import Icon from "@/components/Icons/Icon";
import IconCheck from "@/components/Icons/IconCheck";
import Button from "@/components/ui/buttons/Button";
import { Link } from "@/i18n/routing";

const SuccessStep = ({ apiResponse }: { apiResponse: SellCarRequestResponseDTO }) => {
  return (
    <div className="mt-5">
      <div className="flex items-center rounded-xl bg-green-700 p-3 text-white">
        <Icon icon={<IconCheck fill="#28A244" height="45" width="45" />} backgroundColor="white" className="h-7 w-7" />
        <p className="ml-3 font-inter text-sm font-medium">One of our experts will contact you shortly</p>
      </div>
      <div className="mt-5 rounded-2xl border border-[#ECF0F5] p-7">
        <h4 className="font-inter text-sm font-medium text-secondary-foreground">Your car details</h4>
        <p className="font-inter text-base font-bold text-primary-foreground">
          {`${apiResponse?.brandName} ${apiResponse?.modelName} ${apiResponse?.year}`}
        </p>
        <div className="mt-5 grid max-w-xl gap-y-3 lg:grid-cols-3">
          <div className="flex flex-col space-y-2">
            <span className="intr text-sm font-medium text-secondary-foreground">Milage</span>
            <span className="font-inter text-base font-medium text-primary-foreground">
              {formatNumberWithCommas(apiResponse?.mileage?.toString() ?? "")} Km
            </span>
          </div>
          {/* <div className="flex flex-col space-y-2">
            <span className="font-inter text-sm font-medium text-secondary-foreground">Condition</span>
            <span className="font-inter text-base font-medium capitalize text-primary-foreground">
              {apiResponse?.vehicleOptions}
            </span>
          </div> */}
          {/* <div className="flex flex-col space-y-2">
            <span className="font-inter text-sm font-medium text-secondary-foreground">Approximate price</span>
            <span className="font-inter text-base font-medium text-primary-foreground">
              AED {formatNumberWithCommas(apiResponse?.dealDriveEstimation?.toString() ?? "")}
            </span>
          </div> */}
        </div>
      </div>
      <div className="mt-4 flex items-center lg:justify-end">
        <Link href={"/buy-used-cars-uae"}>
          <Button
            bgColor="primary-light"
            buttonText="Browse Cars"
            textColor="primary"
            className="w-full px-9 py-4 text-center transition-all duration-300 hover:bg-primary hover:text-white lg:max-w-fit"
          />
        </Link>
      </div>
    </div>
  );
};

export default SuccessStep;
